"use strict";
/* eslint-disable max-classes-per-file */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31;
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabServiceProvider = exports.fileServiceProvider = exports.permissionsServiceProvider = exports.supportApiServiceProvider = exports.salesApiServiceProvider = exports.toastServiceProvider = exports.socketServiceProvider = exports.constantsServiceProvider = exports.notificationServiceProvider = exports.interfaceServiceProvider = exports.userServiceProvider = exports.configServiceProvider = exports.StaticLinkComponent = exports.StaticUploadComponent = exports.FileComponent = exports.TierComponent = exports.CommentComponent = exports.DialogCommentsComponent = exports.ProfileImageComponent = exports.StaticResourceComponent = exports.UserNameDircetive = exports.VehicleDetail = exports.DatepickerDirective = exports.UserSelectDirective = exports.SelectDirective = exports.BackdropRailItemComponent = exports.BackdropOverlayContentComponent = exports.BackdropToolbarComponent = exports.BackdropOverlayComponent = exports.CardComponent = exports.BackdropOverlayTitleComponent = exports.BackdropRailComponent = exports.TagDirective = exports.OverlayComponent = void 0;
const core_1 = require("@angular/core");
const static_1 = require("@angular/upgrade/static");
const permissions_service_1 = require("../../components/authorization/permissions.service");
const sales_api_service_1 = require("../../shared/api/sales-api.service");
const support_api_service_1 = require("../../shared/api/support-api.service");
const config_service_1 = require("../../shared/config/config.service");
const constants_service_1 = require("../../shared/config/constants.service");
const web_socket_service_1 = require("../../shared/connections/web-socket.service");
const interface_service_1 = require("../../shared/interface/interface.service");
const users_service_1 = require("../../shared/users/users.service");
const toast_service_1 = require("../../ui-components/toast/toast.service");
const comment_1 = require("./@shared-types/misc/comment");
const notification_service_1 = require("../../shared/browser-functions/notification.service");
const file_service_1 = require("../../shared/storage/file.service");
const file_1 = require("./@shared-types/misc/file");
const tab_service_1 = require("../../shared/browser-functions/tab.service");
let OverlayComponent = class OverlayComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('overlay', elementRef, injector);
    }
};
OverlayComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'overlay',
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _a : Object, typeof (_b = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _b : Object])
], OverlayComponent);
exports.OverlayComponent = OverlayComponent;
let TagDirective = class TagDirective extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('tag', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], TagDirective.prototype, "color", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], TagDirective.prototype, "text", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], TagDirective.prototype, "hover", void 0);
TagDirective = __decorate([
    (0, core_1.Directive)({
        selector: 'tag',
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _c : Object, typeof (_d = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _d : Object])
], TagDirective);
exports.TagDirective = TagDirective;
let BackdropRailComponent = class BackdropRailComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('bdRail', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BackdropRailComponent.prototype, "jump", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Function)
], BackdropRailComponent.prototype, "changeFunction", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Function)
], BackdropRailComponent.prototype, "mainAction", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BackdropRailComponent.prototype, "mainIcon", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BackdropRailComponent.prototype, "mainLink", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BackdropRailComponent.prototype, "mainPermissions", void 0);
BackdropRailComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'bd-rail',
    }),
    __metadata("design:paramtypes", [typeof (_e = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _e : Object, typeof (_f = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _f : Object])
], BackdropRailComponent);
exports.BackdropRailComponent = BackdropRailComponent;
let BackdropOverlayTitleComponent = class BackdropOverlayTitleComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('bdOverlayTitle', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BackdropOverlayTitleComponent.prototype, "title", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Function)
], BackdropOverlayTitleComponent.prototype, "exit", void 0);
BackdropOverlayTitleComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'bd-overlay-title',
    }),
    __metadata("design:paramtypes", [typeof (_g = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _g : Object, typeof (_h = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _h : Object])
], BackdropOverlayTitleComponent);
exports.BackdropOverlayTitleComponent = BackdropOverlayTitleComponent;
let CardComponent = class CardComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('abCard', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "classes", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "action", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Function)
], CardComponent.prototype, "fn", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "titleIcon", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "title", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "titleUser", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "subtitle", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "titleAction", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "titleActionIcon", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "displayIcon", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "displayText", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "mainTitle", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "mainText", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CardComponent.prototype, "mainSubtitle", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], CardComponent.prototype, "ghost", void 0);
CardComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'ab-card',
    }),
    __metadata("design:paramtypes", [typeof (_j = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _j : Object, typeof (_k = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _k : Object])
], CardComponent);
exports.CardComponent = CardComponent;
let BackdropOverlayComponent = class BackdropOverlayComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('bdOverlay', elementRef, injector);
    }
};
BackdropOverlayComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'bd-overlay',
    }),
    __metadata("design:paramtypes", [typeof (_l = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _l : Object, typeof (_m = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _m : Object])
], BackdropOverlayComponent);
exports.BackdropOverlayComponent = BackdropOverlayComponent;
let BackdropToolbarComponent = class BackdropToolbarComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('bdToolbar', elementRef, injector);
    }
};
BackdropToolbarComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'bd-toolbar',
    }),
    __metadata("design:paramtypes", [typeof (_o = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _o : Object, typeof (_p = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _p : Object])
], BackdropToolbarComponent);
exports.BackdropToolbarComponent = BackdropToolbarComponent;
let BackdropOverlayContentComponent = class BackdropOverlayContentComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('bdOverlayContent', elementRef, injector);
    }
};
BackdropOverlayContentComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'bd-overlay-content',
    }),
    __metadata("design:paramtypes", [typeof (_q = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _q : Object, typeof (_r = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _r : Object])
], BackdropOverlayContentComponent);
exports.BackdropOverlayContentComponent = BackdropOverlayContentComponent;
let BackdropRailItemComponent = class BackdropRailItemComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('bdRailItem', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BackdropRailItemComponent.prototype, "title", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BackdropRailItemComponent.prototype, "icon", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BackdropRailItemComponent.prototype, "permission", void 0);
BackdropRailItemComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'bd-rail-item',
    }),
    __metadata("design:paramtypes", [typeof (_s = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _s : Object, typeof (_t = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _t : Object])
], BackdropRailItemComponent);
exports.BackdropRailItemComponent = BackdropRailItemComponent;
let SelectDirective = class SelectDirective extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('abSelect', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], SelectDirective.prototype, "options", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], SelectDirective.prototype, "customModel", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", typeof (_u = typeof core_1.EventEmitter !== "undefined" && core_1.EventEmitter) === "function" ? _u : Object)
], SelectDirective.prototype, "customModelChange", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], SelectDirective.prototype, "multiSelectDelimiter", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], SelectDirective.prototype, "autocomplete", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], SelectDirective.prototype, "placeholder", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], SelectDirective.prototype, "quote", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", typeof (_v = typeof core_1.EventEmitter !== "undefined" && core_1.EventEmitter) === "function" ? _v : Object)
], SelectDirective.prototype, "changeFunction", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", typeof (_w = typeof core_1.EventEmitter !== "undefined" && core_1.EventEmitter) === "function" ? _w : Object)
], SelectDirective.prototype, "customArrayChange", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], SelectDirective.prototype, "required", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], SelectDirective.prototype, "disabled", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], SelectDirective.prototype, "classes", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], SelectDirective.prototype, "showDescription", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], SelectDirective.prototype, "sort", void 0);
SelectDirective = __decorate([
    (0, core_1.Directive)({
        selector: 'ab-select',
    }),
    __metadata("design:paramtypes", [typeof (_x = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _x : Object, typeof (_y = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _y : Object])
], SelectDirective);
exports.SelectDirective = SelectDirective;
let UserSelectDirective = class UserSelectDirective extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('userSelect', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], UserSelectDirective.prototype, "selectedItems", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", typeof (_z = typeof core_1.EventEmitter !== "undefined" && core_1.EventEmitter) === "function" ? _z : Object)
], UserSelectDirective.prototype, "selectedItemsChange", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], UserSelectDirective.prototype, "type", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], UserSelectDirective.prototype, "initSelection", void 0);
UserSelectDirective = __decorate([
    (0, core_1.Directive)({
        selector: 'user-select',
    }),
    __metadata("design:paramtypes", [typeof (_0 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _0 : Object, typeof (_1 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _1 : Object])
], UserSelectDirective);
exports.UserSelectDirective = UserSelectDirective;
let DatepickerDirective = class DatepickerDirective extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('abDatepicker', elementRef, injector);
        this.returnType = 'Date';
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DatepickerDirective.prototype, "selectedDate", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", typeof (_2 = typeof core_1.EventEmitter !== "undefined" && core_1.EventEmitter) === "function" ? _2 : Object)
], DatepickerDirective.prototype, "selectedDateChange", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DatepickerDirective.prototype, "returnType", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DatepickerDirective.prototype, "maxDays", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], DatepickerDirective.prototype, "required", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DatepickerDirective.prototype, "placeholder", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", typeof (_3 = typeof core_1.EventEmitter !== "undefined" && core_1.EventEmitter) === "function" ? _3 : Object)
], DatepickerDirective.prototype, "change", void 0);
DatepickerDirective = __decorate([
    (0, core_1.Directive)({
        selector: 'ab-datepicker',
    }),
    __metadata("design:paramtypes", [typeof (_4 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _4 : Object, typeof (_5 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _5 : Object])
], DatepickerDirective);
exports.DatepickerDirective = DatepickerDirective;
let VehicleDetail = class VehicleDetail extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('vehicleDetail', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", typeof (_6 = typeof core_1.EventEmitter !== "undefined" && core_1.EventEmitter) === "function" ? _6 : Object)
], VehicleDetail.prototype, "exit", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], VehicleDetail.prototype, "vehicleId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], VehicleDetail.prototype, "dummyVehicle", void 0);
VehicleDetail = __decorate([
    (0, core_1.Directive)({
        selector: 'vehicle-detail',
    }),
    __metadata("design:paramtypes", [typeof (_7 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _7 : Object, typeof (_8 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _8 : Object])
], VehicleDetail);
exports.VehicleDetail = VehicleDetail;
let UserNameDircetive = class UserNameDircetive extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('userName', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], UserNameDircetive.prototype, "userId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], UserNameDircetive.prototype, "error", void 0);
UserNameDircetive = __decorate([
    (0, core_1.Directive)({
        selector: 'user-name',
    }),
    __metadata("design:paramtypes", [typeof (_9 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _9 : Object, typeof (_10 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _10 : Object])
], UserNameDircetive);
exports.UserNameDircetive = UserNameDircetive;
let StaticResourceComponent = class StaticResourceComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('staticResource', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], StaticResourceComponent.prototype, "staticId", void 0);
StaticResourceComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'static-resource',
    }),
    __metadata("design:paramtypes", [typeof (_11 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _11 : Object, typeof (_12 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _12 : Object])
], StaticResourceComponent);
exports.StaticResourceComponent = StaticResourceComponent;
let ProfileImageComponent = class ProfileImageComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('profileImage', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], ProfileImageComponent.prototype, "userId", void 0);
ProfileImageComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'profile-image',
    }),
    __metadata("design:paramtypes", [typeof (_13 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _13 : Object, typeof (_14 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _14 : Object])
], ProfileImageComponent);
exports.ProfileImageComponent = ProfileImageComponent;
let DialogCommentsComponent = class DialogCommentsComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('dialogComments', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_15 = typeof comment_1.ECommentContext !== "undefined" && comment_1.ECommentContext) === "function" ? _15 : Object)
], DialogCommentsComponent.prototype, "context", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DialogCommentsComponent.prototype, "contextId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_16 = typeof comment_1.ECommentType !== "undefined" && comment_1.ECommentType) === "function" ? _16 : Object)
], DialogCommentsComponent.prototype, "type", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Function)
], DialogCommentsComponent.prototype, "exit", void 0);
DialogCommentsComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'dialog-comments',
    }),
    __metadata("design:paramtypes", [typeof (_17 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _17 : Object, typeof (_18 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _18 : Object])
], DialogCommentsComponent);
exports.DialogCommentsComponent = DialogCommentsComponent;
let CommentComponent = class CommentComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('comment', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_19 = typeof comment_1.Comment !== "undefined" && comment_1.Comment) === "function" ? _19 : Object)
], CommentComponent.prototype, "comment", void 0);
CommentComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'comment',
    }),
    __metadata("design:paramtypes", [typeof (_20 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _20 : Object, typeof (_21 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _21 : Object])
], CommentComponent);
exports.CommentComponent = CommentComponent;
let TierComponent = class TierComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('tier', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], TierComponent.prototype, "features", void 0);
TierComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'tier',
    }),
    __metadata("design:paramtypes", [typeof (_22 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _22 : Object, typeof (_23 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _23 : Object])
], TierComponent);
exports.TierComponent = TierComponent;
let FileComponent = class FileComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('file', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_24 = typeof file_1.File !== "undefined" && file_1.File) === "function" ? _24 : Object)
], FileComponent.prototype, "file", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], FileComponent.prototype, "fileId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], FileComponent.prototype, "disableDelete", void 0);
FileComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'file',
    }),
    __metadata("design:paramtypes", [typeof (_25 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _25 : Object, typeof (_26 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _26 : Object])
], FileComponent);
exports.FileComponent = FileComponent;
let StaticUploadComponent = class StaticUploadComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('staticUpload', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], StaticUploadComponent.prototype, "documentName", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], StaticUploadComponent.prototype, "identifier", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], StaticUploadComponent.prototype, "inline", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", typeof (_27 = typeof core_1.EventEmitter !== "undefined" && core_1.EventEmitter) === "function" ? _27 : Object)
], StaticUploadComponent.prototype, "exit", void 0);
StaticUploadComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'static-upload',
    }),
    __metadata("design:paramtypes", [typeof (_28 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _28 : Object, typeof (_29 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _29 : Object])
], StaticUploadComponent);
exports.StaticUploadComponent = StaticUploadComponent;
let StaticLinkComponent = class StaticLinkComponent extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        super('staticLink', elementRef, injector);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], StaticLinkComponent.prototype, "staticId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], StaticLinkComponent.prototype, "text", void 0);
StaticLinkComponent = __decorate([
    (0, core_1.Directive)({
        selector: 'static-link',
    }),
    __metadata("design:paramtypes", [typeof (_30 = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _30 : Object, typeof (_31 = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _31 : Object])
], StaticLinkComponent);
exports.StaticLinkComponent = StaticLinkComponent;
const configServiceFactory = (i) => i.get('configService');
exports.configServiceProvider = {
    provide: config_service_1.ConfigService,
    useFactory: configServiceFactory,
    deps: ['$injector'],
};
const userServiceFactory = (i) => i.get('usersService');
exports.userServiceProvider = {
    provide: users_service_1.UsersService,
    useFactory: userServiceFactory,
    deps: ['$injector'],
};
const interfaceServiceFactory = (i) => i.get('interfaceService');
exports.interfaceServiceProvider = {
    provide: interface_service_1.InterfaceService,
    useFactory: interfaceServiceFactory,
    deps: ['$injector'],
};
const notificationServiceFactory = (i) => i.get('notificationService');
exports.notificationServiceProvider = {
    provide: notification_service_1.NotificationService,
    useFactory: notificationServiceFactory,
    deps: ['$injector'],
};
const constantsServiceFactory = (i) => i.get('constantsService');
exports.constantsServiceProvider = {
    provide: constants_service_1.ConstantsService,
    useFactory: constantsServiceFactory,
    deps: ['$injector'],
};
const socketServiceFactory = (i) => i.get('socketService');
exports.socketServiceProvider = {
    provide: web_socket_service_1.SocketService,
    useFactory: socketServiceFactory,
    deps: ['$injector'],
};
const toastServiceFactory = (i) => i.get('toastService');
exports.toastServiceProvider = {
    provide: toast_service_1.ToastService,
    useFactory: toastServiceFactory,
    deps: ['$injector'],
};
const salesApiServiceFactory = (i) => i.get('salesApiService');
exports.salesApiServiceProvider = {
    provide: sales_api_service_1.SalesAPIService,
    useFactory: salesApiServiceFactory,
    deps: ['$injector'],
};
const supportApiServiceFactory = (i) => i.get('supportApiService');
exports.supportApiServiceProvider = {
    provide: support_api_service_1.SupportAPIService,
    useFactory: supportApiServiceFactory,
    deps: ['$injector'],
};
const permissionsServiceFactory = (i) => i.get('permissionsService');
exports.permissionsServiceProvider = {
    provide: permissions_service_1.PermissionsService,
    useFactory: permissionsServiceFactory,
    deps: ['$injector'],
};
const fileServiceFactory = (i) => i.get('fileService');
exports.fileServiceProvider = {
    provide: file_service_1.FileService,
    useFactory: fileServiceFactory,
    deps: ['$injector'],
};
const tabServiceFactory = (i) => i.get('tabService');
exports.tabServiceProvider = {
    provide: tab_service_1.TabService,
    useFactory: tabServiceFactory,
    deps: ['$injector'],
};
